import { ANNOTATION_TYPE } from '@/shared/ui';

type SampleMarkInstance = {
  type: string;
  canvasChart: HTMLCanvasElement;
  ctxChart: CanvasRenderingContext2D | null;
  config: any;
  verticalChannelPlacement: number[];
  displayedChannelsArr: number[];
  pixelSamples: any;
  channelIndex: number;
  startSample: number;
  endSample: number;
  sampleMarkRange: number;
  halfBccHeight: number;
  startY: number;
  endY: number;
  drawOneSampleMark: (offsetX: number, strokeStyle: string) => void;
  update: (
    pixelSamples: any,
    config: any,
    displayedChannelsArr: number[],
    verticalChannelPlacement: number[],
  ) => void;
  getJSONObject: () => {
    type: string;
    channelIndex: number;
    startSample: number;
    endSample: number;
    sampleMarkRange: number;
  };
};
type SampleMarkCtor = new (
  canvasChart: HTMLCanvasElement,
  verticalChannelPlacement: number[],
  config: any,
  displayedChannelsArr: number[],
  pixelSamples: any,
  sampleMark: {
    channelIndex: number;
    startSample: number;
    endSample: number;
    sampleMarkRange: number;
  },
) => SampleMarkInstance;

let SampleMarkImpl: any;

(function () {
  SampleMarkImpl = function (
    canvasChart: HTMLCanvasElement,
    verticalChannelPlacement: number[],
    config: any,
    displayedChannelsArr: number[],
    pixelSamples: any,
    sampleMark: {
      channelIndex: number;
      startSample: number;
      endSample: number;
      sampleMarkRange: number;
    },
  ) {
    this.type = ANNOTATION_TYPE.SAMPLE_MARK;
    this.canvasChart = canvasChart;
    this.ctxChart = this.canvasChart.getContext('2d');
    this.config = config;
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.displayedChannelsArr = displayedChannelsArr;
    this.pixelSamples = pixelSamples;
    this.channelIndex = sampleMark.channelIndex;
    this.startSample = sampleMark.startSample;
    this.endSample = sampleMark.endSample;
    this.sampleMarkRange = sampleMark.sampleMarkRange;
  };

  SampleMarkImpl.prototype.drawOneSampleMark = function (offsetX: number, strokeStyle: string) {
    const { sampleLength, numberOfVisibleChannels, height } = this.config;

    this.ctxChart.beginPath();
    this.ctxChart.strokeStyle = strokeStyle;
    this.halfBccHeight = height / 2 / numberOfVisibleChannels;

    if (this.endSample < 0) {
      this.endSample = 0;
    }

    if (this.endSample >= sampleLength) {
      this.endSample = sampleLength - 1;
      this.sampleMarkRange = this.endSample - this.startSample;
    }

    if (this.startSample < 0) {
      this.startSample = 0;
      this.sampleMarkRange = this.endSample - this.startSample;
    }

    if (this.startSample >= sampleLength) {
      this.startSample = sampleLength - 1;
      this.sampleMarkRange = this.endSample - this.startSample;
    }
    this.displayedChannelsArr.forEach((element: number, index: number) => {
      if (this.channelIndex === element) {
        this.startY = this.verticalChannelPlacement[index] - this.halfBccHeight;
        this.endY = this.verticalChannelPlacement[index] + this.halfBccHeight;

        // draw first vertical line
        this.ctxChart.moveTo(
          this.pixelSamples[index][this.startSample].x - this.pixelSamples[index][offsetX].x,
          this.startY,
        );
        this.ctxChart.lineTo(
          this.pixelSamples[index][this.startSample].x - this.pixelSamples[index][offsetX].x,
          this.endY,
        );

        // draw last vertical line
        this.ctxChart.moveTo(
          this.pixelSamples[index][this.endSample].x - this.pixelSamples[index][offsetX].x,
          this.startY,
        );
        this.ctxChart.lineTo(
          this.pixelSamples[index][this.endSample].x - this.pixelSamples[index][offsetX].x,
          this.endY,
        );

        // draw sample mark line
        for (
          let j = Math.min(this.startSample, this.endSample);
          j < Math.max(this.startSample, this.endSample);
          j += 1
        ) {
          if (j < this.config.sampleLength) {
            // out-range conditional
            this.ctxChart.moveTo(
              this.pixelSamples[index][j].x - this.pixelSamples[index][offsetX].x,
              this.pixelSamples[index][j].y,
            );
            this.ctxChart.lineTo(
              this.pixelSamples[index][j + 1].x - this.pixelSamples[index][offsetX].x,
              this.pixelSamples[index][j + 1].y,
            );
          } else {
            break;
          }
        }
      }
    });
    this.ctxChart.stroke();
    this.ctxChart.closePath();
  };

  SampleMarkImpl.prototype.update = function (
    pixelSamples: any,
    config: any,
    displayedChannelsArr: number[],
    verticalChannelPlacement: number[],
  ) {
    this.pixelSamples = pixelSamples;
    this.config = config;
    this.displayedChannelsArr = displayedChannelsArr;
    this.verticalChannelPlacement = verticalChannelPlacement;
  };

  SampleMarkImpl.prototype.getJSONObject = function () {
    return {
      type: this.type,
      channelIndex: this.channelIndex,
      startSample: this.startSample,
      endSample: this.endSample,
      sampleMarkRange: this.sampleMarkRange,
    };
  };
})();

const SampleMark: SampleMarkCtor = SampleMarkImpl;

export { SampleMark };
export default { SampleMark };
